import { mountHud } from './hud';
import { mountBottomNav } from './bottomNav';

/** Create / wire the DOM overlay for M0. */
export function mountUI(): void {
  const hud = document.getElementById('hud');
  const nav = document.getElementById('bottom-nav');
  if (!hud || !nav) {
    throw new Error('HUD or bottom-nav root missing from index.html');
  }
  mountHud(hud);
  mountBottomNav(nav);
}
